;
/* Amend fn_checkInvalid for new validations Mar 13, 2022 */
/* Add Proposal(PS)  to Altview Jan 8, 2023 */
/* Add Reminders and Notifications Apr 29, 2023 */
/* Amend delete record  Jun 3, 2023 */
/* Add header1-sticky left-icon-fixed arrow-left Jun 18, 2023 */
/* Add Opportunity Team(OT) Dec 30, 2023 */
/* Change z-index to 2 for header1-sticky, amend btn-outline-primary Apr 13, 2024 */
/* Add voice Component June 1, 2024 */
/* Add acct to c_allowDelete and use :title Jul 20, 2024 */
/* Add Email button for OT Sep 21, 2024 */
/* Add p_requiredColumns Jan 31, 2025 */
/* Add Bug fix on fn_checkInvalid Apr 26, 2025 */
/* Amend Notes placement May 30, 2025 */
/* Add rec-form-header June 21, 2025 */
/* Inject vcrec, use vc.$parent||vc.vcrec  Feb 28 , 2026 */
/* Add add full Proposal(FPS), Emoji  Mar 15, 2026 */
/* Add cmpt to the use of vcrec for Competitor changes April 11, 2026 */
/* Add contact card upload  May 15, 2026 */
/* Add CPS for Proposal for full Proposal Jun 29, 2026 */
/* Add close to kt-notes for notes on tableJuly 11, 2026 */
<template lang="pug">
	div(class="rec-wrap" :class="'rec-' + p_mode")
		//- Header 1
		div(class="rec-wrap-header-1 header1-sticky" v-if="p_mode!='task'")
			div(v-if="/^(create|edit)$/.test(p_mode) && !p_isModal" class="flex-wrap")
				b-button(id="btn-save" class="btn-save"  title="Save" variant='primary' @click="m_save()") Save
				b-button(id="btn-cancel" class="btn-cancel" title="Cancel" variant="outline-secondary" @click="m_cancel()") Cancel
				h6
					fa-icon(:icon="c_hdr1Title.icon" class="mr-1")
					span {{c_hdr1Title.title}}
				div(style="position:absolute;right:5px;display:flex")
					b-button(v-if="/^(oppr|proj|acct|extr|cmpt)$/.test(p_appEntKey)" @click="m_showNotes" variant="none" right lazy no-caret title="Notes")
						fa-icon(icon="pen-alt" class="notes-btn")
					kt-vcomponent(@focused="m_emitFocused" @voice="m_processVoice")
					b-button(v-if="/^(extr)$/.test(p_appEntKey)" class="btn-upload" title="Upload file" style="border:none;" variant="outline-primary" @click="m_fileUpload")
						b-icon(icon="upload")
				kt-notes(v-if="d_showNotes" :key="p_recData[d_appEnt.idKey]" :p_recordContext="d_appEnt.idKey" :p_recordId="p_recData[d_appEnt.idKey]" p_mode="edit" :p_save="d_savedRecord" p_class="dropdown-edit2" @close="m_showNotes")
				div(class="cln-tsk" v-if="$route.params.clone")
					input(type="checkbox" :checked="false" v-model="p_recData._cloneTasks") 
					span Clone Activities
					kt-tt-info(:p_infoTxt="`You may also copy all activities from the ${c_apppEntName} being cloned (if any exist). The copied activities will be available to edit after saving the new ${c_apppEntName}.`")
			div(v-if="p_mode == 'view' && !p_isModal" class="left-icons-fixed toolbar")
				div
					b-button(class="btn-back" title="Back" variant="outline-primary" @click="m_goBack" v-show="!p_altView")
						fa-icon(icon="arrow-left")
					b-button(class="btn-edit" title="Edit" variant="primary" @click="m_edit()" v-show="!p_altView")
						//- fa-icon(icon="edit")
						|Edit
					b-button(v-if="p_enableClone && p_mode=='view' && !p_isModal && !p_altView"
						class="btn-clone" title="Clone as New" variant="outline-primary" @click="m_clone()")
						//- fa-icon(icon="clone")
						|Clone
					b-button(class="btn-back" title="Back" variant="outline-primary" v-if="p_altView!==undefined"
						@click="$emit('altViewChg', null)" v-show="p_altView")
						//- fa-icon(icon="undo")
						fa-icon(icon="arrow-left")
						//-|Back
				div(class="toolbar")
					b-button(v-for="av in c_altViewBtns" :key="av.key" class="btn-alt-view" variant="outline-secondary1" :pressed="p_altView==av.key" @click="m_clickAltView(av.key)")
						fa-icon(v-if="av.icon" :icon="av.icon")
						span(v-else-if="av.emoji") {{av.emoji}}
						|{{av.label}}
				div(v-if="p_altView=='PS'")
					b-dropdown(variant="outline-primary" right lazy title="Templates"  toggle-class="btn-menu" class="dropdown-on-top")
						template(v-slot:button-content )
							fa-icon(icon="file-alt" )
						b-card(class="cardDropDown")
						<b-row class="d-flex flex-wrap align-items-center px-2 mt-2">
							<b-col class="w-100">
								<input 	id="templateName" type="text" class="w-100 border" 	v-model="d_templateName" size="10" placeholder="Template Name" />
							</b-col>
							<b-col class="w-50">
								<b-button :disabled="!d_templateName" variant="outline-secondary" class="btn-link w-100 p-0 noborder" 	@click="m_saveProposalTemplate" >Save as a Template</b-button>
							</b-col>
						</b-row>
						<b-row class="d-flex flex-wrap align-items-center px-2 mt-2">
							<b-col class="w-50">
								b-form-select(size="xs" v-model="d_selectedTemplate" :options="c_proposalTemplates" value-field="proposalName" text-field="proposalName"  )
									<template #first>
										<b-form-select-option :value="null" selected>Choose Template</b-form-select-option>
									</template>
							</b-col>
							<b-col class="w-50">
								<b-button :disabled="!d_selectedTemplate" variant="outline-secondary" class="btn-link w-100 p-0 noborder" @click="m_applyProposalTemplate" >Apply Template</b-button>
							</b-col>
						</b-row>
					<b-button type="button"  :variant="d_previewPdf?'success':'outline-secondary'" :title="d_previewPdf?'Back to form':'Preview'"  style="width1: 1.5em; height1: 1.5em; border:none;" @click="m_emitPreviewPdf">
							<svg role="img" class="svg-icon" style="width: 1.5em; height: 1.5em;vertical-align: middle;fill: currentColor;overflow: hidden;" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
							<path  d="M545 793.6H243.8c-11 0-20-9-20-20V250.4c0-11 9-20 20-20h432.4c11 0 20 9 20 20v131.8c0 11 9 20 20 20s20-9 20-20V250.4c0-33.1-26.9-60-60-60H243.8c-33.1 0-60 26.9-60 60v523.2c0 33.1 26.9 60 60 60H545c11 0 20-9 20-20s-8.9-20-20-20z"  />
							<path  d="M834.6 789.8l-88.8-91.7c23.4-28.7 37.5-65.4 37.5-105.3 0-92.1-74.9-167-167-167s-167 74.9-167 167 74.9 167 167 167c37.8 0 72.7-12.6 100.7-33.9l89 91.8c3.9 4 9.1 6 14.3 6 5 0 10.1-1.9 14-5.7 7.8-7.6 8-20.3 0.3-28.2z m-218.4-69.9c-70 0-127-57-127-127s57-127 127-127 127 57 127 127-57 127-127 127zM565 382.2c0-11-9-20-20-20H308.7c-11 0-20 9-20 20s9 20 20 20H545c11.1 0 20-9 20-20zM443.5 493.5c0-11-9-20-20-20H308.7c-11 0-20 9-20 20s9 20 20 20h114.8c11.1 0 20-8.9 20-20zM308.7 584.8c-11 0-20 9-20 20s9 20 20 20h61.7c11 0 20-9 20-20s-9-20-20-20h-61.7z"/>
							</svg>
					</b-button>
					b-button( title="Save" variant="outline-secondary"  @click="$emit('saveProposal')")
						fa-icon(icon="save")
					b-button(class="btn-pdf" title="Generate Pdf" variant="outline-danger" @click="$emit('generatePdf')")
						fa-icon(icon="file-pdf")
					//b-button(class="btn-menu" title="Email Pdf" variant="outline-secondary" @click="$emit('emailPdf')")
						//fa-icon(icon="envelope")
				div(v-if="p_altView=='OT'" title="Export and Reports")
					b-button(class="btn-menu" @click="$emit('OpportunityTeamEmail')"  variant="outline-success" title="Email")
						fa-icon(icon="envelope" style="color: green;")
					b-button(class="btn-menu" @click="$emit('OpportunityTeamExcel')"  variant="outline-success" title="Export to Excel") 
						fa-icon(icon="file-excel" style="color: green;")
					b-button(class="btn-menu" title="Generate Pdf" variant="outline-danger" @click="$emit('OpportunityTeamPdf')")
						fa-icon(icon="file-pdf" style="color: red;")
				div(v-else-if="!p_altView" class="right-icons-fixed")
					b-button(class="btn-note" v-if="/^(oppr|proj|acct|extr|cmpt)$/.test(p_appEntKey)" @click="m_showNotes" variant="none" right lazy no-caret title="Notes")
						fa-icon(icon="pen-alt" class="notes-btn")
					kt-notes(v-if="d_showNotes" :key="p_recData[d_appEnt.idKey]" :p_recordContext="d_appEnt.idKey" :p_recordId="p_recData[d_appEnt.idKey]" p_mode="edit" :p_save="d_savedRecord" p_class="dropdown-edit1" @close="m_showNotes")
					b-dropdown(v-if="/^(oppr|proj|acct)$/.test(p_appEntKey)"
						class="opt-reminder" right lazy no-caret variant="outline-secondary"
						:title="{title:'Reminders for this ' + c_apppEntName}")
						template(v-slot:button-content)
							//- fa-icon(:icon="['far', 'bell']")
							fa-layers
								fa-icon(:icon="['far', 'bell']")
								fa-layers-text(class="kt-bbl" transform="up-15 right-15" :value="c_rmndOptTrue.length" v-if="(c_rmndOpt||[]).length")
						kt-remind-opt(:p_appEnt="d_appEnt" :p_recData="p_recData" :p_rmndOpt="p_rmndOpt")
					b-button(class="btn-chat" variant="outline-secondary" @click="m_startChat"
						:title="'Start New Chat about this ' + c_apppEntName")
						fa-icon(icon="comments")
					b-button(v-if="c_allowDelete" :disabled="!c_deletePermission" class="btn-delete" variant="outline-secondary" @click="m_delete"
						:title="'Delete this ' + c_apppEntName")
						fa-icon(icon="trash-alt")
					b-button(class="btn-refresh" variant="outline-secondary" @click="m_refresh"
						:title="'Refresh'" :disabled="!!p_altView" )
						fa-icon(icon="sync")
					b-button(v-if="/^(extr)$/.test(p_appEntKey)" class="btn-upload" title="Upload file" style="border:none;" variant="outline-primary" @click="m_fileUpload")
						b-icon(icon="upload")


		//- rec-wrap-flow
		//- slot(name="rec-wrap-flow" v-if="/^(oppr|proj)$/.test(p_appEntKey) && !p_altView")
		//- Header 2
		div(class="rec-wrap-header-2 header2-sticky" v-if="p_altView!==undefined && p_altView")
			span {{c_recordLabel}}
		kt-spinner(v-if="d_loading" :p_txt="c_apppEntName")
		//- rec-wrap-task (Task Only)
		slot(v-if="p_mode =='task'" name="rec-wrap-task" v-show="!d_loading")
		//- rec-alt-view
		slot(v-else-if="p_altView" name="rec-alt-view" v-show="!d_loading")
		//- rec-wrap-form
		div(v-else class="rec-wrap-form" v-show="!d_loading")
			b-form(ref="rec-form" class="rec-form row no-gutters text-left flex-grow-1")
				b-form(ref="rec-form" class="rec-form row1")
					slot(name="rec-form-header")
				b-form-group(class="rec-form-left col-12 col-md-6" :disabled="p_mode=='view'")
					slot(name="rec-form-left")
				b-form-group(class="rec-form-right col-12 col-md-6" :disabled="p_mode=='view'")
					slot(name="rec-form-right")
				b-form-group(class="rec-form-center col-12" :disabled="p_mode=='view'")
					slot(name="rec-form-center")
				div(v-if="/^(create|edit)$/.test(p_mode) && !p_isModal" class="d-flex flex-row")
					b-button(id="btn-save" class="btn-save"  title="Save" variant='primary' @click="m_save()") Save
					b-button(id="btn-cancel" class="btn-cancel" title="Cancel" variant="outline-secondary" @click="m_cancel()") Cancel
			//-rec-wrap-rec-meta
			div(v-if="/^(view|edit)$/.test(p_mode)" class="rec-wrap-rec-meta text-left rec-wrap-meta-sticky")
				div(class="text-left")
					b-button(class="btn-rec-meta"  size="sm" variant="none"
						@click="d_showRecMeta = !d_showRecMeta")
						fa-icon(icon="bars")
				div(v-show="d_showRecMeta"  class="px-2 py-2")
					label {{c_apppEntName + ' Id'}}
					p
						fa-icon(icon="key" size="sm" class="mr-2") 
						| {{p_recData[d_appEnt.idKey]}}
					label Created (UTC)
					p {{d_util.fn_fmtDtm(p_recData.createdUTC)}}
					label Created By
					p {{p_recData.createdBy}}
					label  Last Updated (UTC)
					p {{d_util.fn_fmtDtm(p_recData.updatedUTC) || 'N/A'}}
					label Last Updated By
					p {{p_recData.updatedBy || 'N/A'}}

		
		
		//-Create Duplicate Check
		div(v-if="p_mode == 'create' && d_duplicates" class="rec-create-dups my-3")
			div(class="border border-grey5 text-left p-3")
				p(class="mt-0 mb-2")
					fa-icon(icon="exclamation-triangle"  class="text-warning mr-2")
					| Duplicate Check
				p(class="my-0") Please review the list below for possible duplicates of the {{c_apppEntName}} you are creating.
				| After Reviewing Click "Save {{p_isModal? ' and Add': ''}}" once more to create the new {{c_apppEntName}}. Otherwise click "Cancel"
				div(class="text-muted mt-2")
					b-tr(v-for="(d,ix) in d_duplicates" :key="ix")
						b-td(class="btn btn-sm btn-link" @click="m_dup_viewModal(d)") {{d[d_appEnt.numKey]}}
						b-td(v-for="(k, kix) in Object.keys(d).filter(x=> x!= d_appEnt.numKey)" :key="kix") {{d[k]}}
		

		//-MODAL bm-rec-wrap for KT-Select & KT-List
		b-modal(v-if="d_bmId && !p_altView" :id="d_bmId" ref="bm-rec-wrap"
			size="lg" centered=true  no-fade hide-header-close no-close-on-backdrop 
			no-close-on-esc header-bg-variant="light" footer-class="justify-content-start" 
			@hidden="Object.keys(d_modal).forEach(k => d_modal[k] = null)")
			
			//--Modal Header
			template(slot="modal-header")
				span {{c_modalTitle}}
			//----Create New Record
			component(v-if="d_modal.createNew" ref="rec-create-new" :is="c_modalComponent" p_mode="create" :p_isModal="true" )
			//----View Record
			component(v-else-if="d_modal.recNo" ref="rec-view" :is="c_modalComponent" p_mode="view" :p_isModal="true" :p_recNo="d_modal.recNo")
			//--Modal Footer
			template(slot="modal-footer" slot-scope="{ ok, cancel, hide }")
				b-button(v-if="d_modal.createNew" variant="primary" @click="m_modal_saveAndAdd" ) Save and Add
				b-button(v-if="d_modal.createNew" variant="outline-secondary" @click="m_modal_cancel()") Cancel

				b-button(v-if="d_modal.recNo" variant="outline-secondary" @click="m_modal_cancel()") Close
				span(v-if="d_modal.recNo" class="btn btn-link" @click="m_modal_view(false)") Open in Current Tab
				span(v-if="d_modal.recNo") | 
				span(v-if="d_modal.recNo" class="btn btn-link" @click="m_modal_view(true)") Open in New Tab
</template>

<script>
import util, {kbdpAlert, fn_getHashId} from "@/utils/util.js";
import {userInfo,userSettings,refData,fn_appEnt} from "@/utils/ref-data.js";
import {fn_getReferenceData,fn_getProposalTemplates,fn_getRecord, fn_deleteRecord, fn_checkDuplicates} from "@/utils/api.js";
import KTReminderOpts from '@/components/Ctrl/KT-ReminderOpt.vue';
import { eventBus } from '@/main';
import {m_processFileUploadAI} from "@/utils/callAIUtil.js";
export default {
	name: "rec-wrap",
	inject: ["vcrec"],
	components: {
		//'kt-remind-opt': () => import("@/components/Ctrl/KT-ReminderOpt.vue"),
		"kt-remind-opt":KTReminderOpts,
		"kt-vcomponent": () => import('@/components/Ctrl/KT-VoiceComponent.vue'),
		'kt-notes': () =>import("@/components/Ctrl/KT-Notes.vue"),
		'kt-action-menu': () =>import("@/components/KT-ActionMenu.vue"),
		},
	created() {
		eventBus.$on('saved', (data) => {this.p_rmndOpt=[...data];});
		this.d_rmndOpt=this.p_rmndOpt;
		fn_loadRecData(this);
	},
	mounted() {
	fn_getReferenceData().then(resp => {
			console.log('fn_getReferenceData');
			console.log(resp);
			this.d_proposalTemplates=resp.proposalTemplates;
			});
			
	
	},
	data() {
		return {
			d_util: util,
			d_appEnt: fn_appEnt(this.p_appEntKey),
			d_modal: {
				appEntKey: null,
				createNew: null,
				saveNewFn: null,
				recNo: null,
			},
			d_loading: null,
			d_bmId: $('.rec-wrap').length > 1 ? null : ('bm-rec-wrap' + (this.p_isModal ? '-nested' : '')),

			d_showRecMeta: false,
			d_duplicates: null,
			d_previewPdf:false,
			d_templateName:null,
			d_selectedTemplate:null,
			//d_proposalTemplates: refData.proposalTemplates,
			d_proposalTemplates:null,
			d_rmndOpt:[],
			d_teamMemberId:userInfo.getUserInfo().teamMember.teamMemberId,
			d_perms: userSettings.permissions,
			d_showNotes:window.sessionStorage['rec-show-notes-'+this.p_appEntKey]||false,
			d_extraMenuItems: {
				oppr: [
						{
						label: "Proposal",
						emoji: "💼",
						title: "Create full Proposal",
						onClick: () => this.$emit("altViewChg", "FPS"),
						},
					],
				},
			d_openExtraMenu:false, 
	};
	},
	props: {
		p_mode: String,
		p_appEntKey: String,
		p_saveFn: Function,
		p_isModal: Boolean,
		p_recData: Object,
		p_rmndOpt: Array,
		p_enableClone: {type: Boolean, default: null},
		// p_enableEdit: {type: Boolean, default: true},
		p_altView: {type: String, default: undefined},
		p_requiredColumns: Array,
	},
	computed: {
		c_deletePermission(){ 
							return this.p_recData.teamMemberId==this.d_teamMemberId||this.d_perms.superUser;
							},
		c_modalComponent() {
			return (fn_appEnt(this.d_modal.appEntKey) || {}).importRecComp || null;
		},
		c_modalTitle() {
			let dm = this.d_modal;
			let dmae = fn_appEnt(dm.appEntKey);
			if (dm.createNew) return 'Create New ' + dmae.Name;
			if (dm.recNo) return 'View ' + dmae.Name;
			return null;
		},
		c_apppEntName() {
			return this.d_appEnt ? util.fn_humanizeLabel(this.d_appEnt.name) : null;
		},
		c_hdr1Title() {
			let appEntNm = this.c_apppEntName;
			let title;
			let icon;
			if (this.p_mode == 'edit') {
				title = "Edit " + appEntNm;
				icon = 'edit';
			}
			else if (this.p_mode == 'create') {
				let clone = this.$route.params.clone;
				if (clone) {
					title = 'Clone ' + appEntNm;
					icon = 'clone';
				}
				else {
					title = 'Create ' + appEntNm;
					icon = 'folder-plus';
				}
			}

			return {title, icon};
		},
		c_recordLabel() {
			let numK = this.d_appEnt.numKey;
			let nameK = this.d_appEnt.nameKey;
			return util.fn_recLbl(this.p_recData[numK], this.p_recData[nameK]);
		},
		c_allowDelete() {
			let aek = this.p_appEntKey;
			return /^(oppr|acct|proj|extr|cmpt|team)$/.test(aek) && !(aek == 'team' && this.p_recData.appUserName);
		},
		c_altViewBtns() {
			let av = this.d_appEnt.altView;
			if (!av) return [];
			return [
				{key: 'TASK', label: 'Activities', icon: 'tasks'},
				{key: 'AT', label: 'Documents', icon: 'folder-open'},
				{key: 'RR', label: 'Related', icon: 'sitemap'},
				{key: 'DECS', label: 'Decision (Go-No-Go)', icon: 'traffic-light'},
				{key: 'BI', label: 'Business Insights', icon: 'chart-line'},
				{key: 'DB', label: 'Debrief', icon: 'clipboard-list'},
				{key: 'PS', label: 'Bid Form', icon: 'clipboard-check'},
				{key: 'OT', label: 'Team Build', icon: 'user-friends'},
				{key: 'CPS', label: 'Proposal', emoji: "💼"},
			].filter(x => av.indexOf(x.key) > -1);
		},
		c_proposalTemplates(){return this.d_proposalTemplates;},
		c_rmndOpt(){ return this.p_rmndOpt},
		c_rmndOptTrue(){ return this.p_rmndOpt?this.p_rmndOpt.filter(o=>o.email||o.kbdp):null;},
		c_extraMenu() { return this.d_extraMenuItems[this.p_appEntKey]||null;}
	},
	methods: {
		m_emitFocused(e){
		if(this.p_altView) eventBus.$emit('focused',{context:this.p_altView,event:e}); 
			else this.$emit('focused',e);
		},
		m_processVoice(e){
		
		console.log('In m_processVoice');
		console.log(e);
		
		if(/^(Save|save)/.test(e)) document.getElementById("btn-save").click();
		else
		if(/^(Cancel|cancel)/.test(e)) document.getElementById("btn-cancel").click();
		else
		if(this.p_altView) eventBus.$emit('voice',{context:this.p_altView,event:e});
		else this.$emit('voice',e);
		},
		m_edit() {
			if (this.p_isModal) return;

			let href = this.$route.hash.replace('-view', '-edit');
			this.$router.push(href);
		},
		m_save() {
			let msg = fn_checkInvalid(this);
			if (msg) {
				kbdpAlert.showErr(msg);
				return;
			}
			else {
				kbdpAlert.clear();
			}
			if (this.p_mode == 'create' && !this.d_duplicates) {
				fn_chkDups(this, null);
			}
			else {
				fn_saveRoutine(this);
			}
		},
		m_cancel() {
			fn_wss_rwsc();
			this.$emit('canceled', null);
			if (this.p_mode == 'edit') {
				let href = this.$route.hash.replace('-edit', '-view');
				this.$router.push(href);
			}
			if (this.p_mode == 'create') {
				this.$router.go(-1);
			}
		},
		m_clone() {
			this.$router.push({
				name: 'KBDP',
				hash: `#${this.d_appEnt.key}-create`,
				params: {'clone': true}
			});
		},

		m_refresh() {
			fn_loadRecData(this);
		},
		m_delete() {
			fn_deleteRoutine(this);
		},
		m_startChat(e) {

			if (e.detail > 1) return;

			let appEntKey = this.d_appEnt.key;
			let recNo = this.p_recData[this.d_appEnt.numKey];

			let relatedRecord = {
				label: this.c_recordLabel,
				href: util.fn_hrefVwRec(appEntKey, recNo)
			};

			let ktc = $(this.$root.$el).find('#kt-chat')[0].__vue__;
			if (!ktc) return;

			let existing = ktc.d_chats.filter(x => {
				return (x.relatedRecord || {}).href == relatedRecord.href
					&& x.isHost && x.chatTitle == null && (x.participants || []).length == 1;
			})[0];

			if (existing) {
				ktc.d_chatCrnt = existing;
				return;
			}
			ktc.m_startNewChat(e, relatedRecord);
		},

		m_dup_viewModal(d) {
			let appEntKey = this.d_appEnt.key;
			let recNo = d[this.d_appEnt.numKey];

			if (this.d_bmId) {
				this.d_modal.appEntKey = appEntKey;
				this.d_modal.recNo = recNo;
				this.$bvModal.show(this.d_bmId);
			}
			else {
				window.open(util.fn_hrefVwRec(appEntKey, recNo), '_blank');
			}
		},

		//Modal Functions
		m_modal_saveAndAdd(e) {
			let dm = this.d_modal;
			let vc_modal = this.$refs['rec-create-new'].$children[0];
			let msg = fn_checkInvalid(vc_modal);
			if (msg) {
				e.preventDefault();
				kbdpAlert.showErr(msg);
				return;
			}
			else {
				kbdpAlert.clear();
			}
			if (!vc_modal.d_duplicates)
				fn_chkDups(vc_modal, e, dm.saveNewFn);
			else
				dm.saveNewFn();
		},
		m_modal_cancel() {
			this.$bvModal.hide(this.d_bmId);
		},
		m_modal_view(newTab) {
			let dm = this.d_modal;
			let href = util.fn_hrefVwRec(dm.appEntKey, dm.recNo);
			if (newTab) {
				window.open(href, '_blank');
			}
			else {
				['bm-rec-wrap-nested', 'bm-rec-wrap', 'bm-kt-task', 'bm-kbdp-view-rec'].forEach(bm => {
					this.$bvModal.hide(bm);
				});
				setTimeout(() => {
					window.open(href, '_self');
				}, 200);

			}
		},
		m_emitPreviewPdf(){
				this.d_previewPdf=!this.d_previewPdf;
				this.$emit('previewPdf');
				},		
		m_saveProposalTemplate(){
			console.log('Emit saveProposalTemplate:'+this.d_templateName);
			this.$emit('saveProposalTemplate', this.d_templateName);
			this.d_templateName=null;
			//this.d_proposalTemplates=refData.proposalTemplates;
			fn_getReferenceData().then(resp => {
				console.log('fn_getReferenceData');
				console.log(resp);
				this.d_proposalTemplates=resp.proposalTemplates;
			});
		},
		m_applyProposalTemplate(){
			console.log('Emit applyProposalTemplate:'+this.d_selectedTemplate);
			this.$emit('applyProposalTemplate', this.d_selectedTemplate);
			this.d_selectedTemplate=null;
		},
		m_goBack() {
			if (this.$route.hash != '') {
				//this.$router.push({name: 'KBDP'});
				this.$router.push({path: '#' + this.d_appEnt.key});
			}
		},
		m_showNotes(){
			console.log('In m_showNotes');
			
			let wss = window.sessionStorage;
			let uc = 'unsaved-changes';
			if(!wss[uc]) this.d_showNotes=!this.d_showNotes;
				else {
			
					let content = {
								titleText: 'Unsaved Notes',
								message1: 'You may have unsaved note(s)',
								message2: 'Are you sure you want to discard the note(s)?',
								};
					let cm = util.fn_getModal_confirm(this, content);
		
					cm.opt.okTitle += ', Leave';
					cm.opt.cancelTitle += ', Stay';
			
		
					cm.opt.size='md';
					cm.opt.headerClass='p-2';
					cm.opt.headerBgVariant='primary';
					cm.opt.buttonSize='sm';
					cm.opt.okVariant='primary';
					cm.opt.footerClass='p-2 border-top-0';
					cm.opt.centered=true;
		
					this.$bvModal.msgBoxConfirm(cm.msgVNodes, cm.opt).then((resp) => {
					if(resp){
						wss.removeItem(uc);
						this.d_showNotes=!this.d_showNotes;
						}
					});
		
				}
			console.log(this.d_showNotes);
			window.sessionStorage.setItem('rec-show-notes-'+this.p_appEntKey, this.d_showNotes);
		},
		m_clickAltView(key) {
			this.d_openExtraMenu=false;
			this.$emit('altViewChg', key);
		},
		m_closeExtraMenu(){this.d_openExtraMenu=false;},
		m_fileUpload(){

		const input = document.createElement("input");
		input.type = "file";
		
		input.onchange = (e) => {
			const file = e.target.files[0];
			m_processFileUploadAI(this.p_appEntKey,file);
		};

		input.click();
		},
	},
	watch: {
		$route(nv, ov) {
			let recNo = fn_getHashId(this);

			let vcp = this.p_appEntKey=='team'||this.p_appEntKey=='cmpt'?this.vcrec:this.$parent;
			if (this.p_mode == 'create') {
				if (nv.params.clone) {
					fn_cloneRecData(vcp, this);
				}
				else {
					vcp.d_recData = {};
				}
				if (vcp.m_setDefaults) vcp.m_setDefaults();
			}
			else if (recNo) {
				vcp.d_recNo = recNo;
				fn_loadRecData(this);
			}

			vcp.d_altViewKey = null;//Must do this. altview doesn't get refreshed.

			this.d_duplicates = null;
		}
	},
};

function fn_loadRecData(vc) {
    var customData;

	let vcrec = vc.p_appEntKey=='team'||vc.p_appEntKey=='cmpt'?vc.vcrec:vc.$parent
	console.log(`In fn_loadRecData ${vcrec.d_recNo } , ${vc.d_appEnt}`);
	if (!vcrec.d_recNo || !vc.d_appEnt) return;
	vc.d_loading = true;
	fn_getRecord(vc.d_appEnt.name, vcrec.d_recNo).then((resp) => {
		if (resp.recordData)
			vcrec.d_recData = resp.recordData;
		else {
			let msg = resp.error || `Unable to find ${vc.d_appEnt.name}: "${vcrec.d_recNo}"`;
			vcrec.$emit('error', msg);
		}
		if (resp.reminderOptions) {
			vcrec.d_rmndOpt = resp.reminderOptions;
		}
		vc.d_loading = null;
	});
}
function fn_cloneRecData(vcp, vc) {

	let ae = vc.d_appEnt;
	let ignoreList = [
		'createdUTC',
		'createdById',
		'updatedUTC',
		'updatedById',
		ae.idKey,
		ae.numKey,
		...(vcp.d_noClone || [])
	];
	let recData_New = {
		_cloneId: vcp.d_recData[ae.idKey]
	};
	let keysClone = Object.keys(vcp.d_recData).filter(x => ignoreList.indexOf(x) == -1);
	keysClone.forEach(x => {
		recData_New[x] = vcp.d_recData[x];
	});
	vcp.d_recData = recData_New;
}

function fn_checkInvalid(vc) {
	let recform = $(vc.$refs['rec-form']);
	let invalid = [];
	


	
	
	let ist1 = recform.find('.is-invalid').filter('input, select, textarea', 'form-control');
	console.log('ist1 ost2 kts kts2');
	let ist2 = recform.find(':invalid').filter('input, select, textarea');
	let kts = recform.find('.kt-select .input[invalid]');
	


	//$.merge(ist, kts).closest('.form-group').children('label').each((i, e) => {invalid.push(e.textContent);});
	$.merge(ist1,$.merge(ist2, kts)).closest('.form-group').children('label').each((i, e) => {invalid.push(e.textContent);});
	
	
	
	let vcrec = vc.p_appEntKey=='team'||vc.p_appEntKey=='cmpt'?vc.vcrec:vc.$parent;
	console.log('vcrec.d_recData');
	console.log(vcrec.d_recData);
	console.log('vc.p_requiredColumns');
	console.log(vc.p_requiredColumns);
	
	console.log('vcrec.d_requiredColumns');
	console.log(vcrec.d_requiredColumns);
	
	let customData=vcrec.d_recData['customData'];
	let val;
	let fieldVal;
	
	if(vcrec.d_requiredColumns) {
		vcrec.d_requiredColumns.forEach(c=>{val=vcrec.d_recData[c.field];
									if(!val&&customData) val=customData[c.field];
									fieldVal=val instanceof Array?val[0]:val;
									if(!fieldVal&&!invalid.includes(c.title)&&
										!['opportunityNo','accountNo','projectNo','competitorNo',
										'externalContactNo','teamMemberNo'].includes(c.field) )
										invalid.push(c.title);
									});
			}
		
		
	if (invalid.length) {
		// ist.first().focus();
		return 'Please enter a valid value for the following field(s):\n"' + invalid.join('"\n"') + '"';
	}
	return null;
}

function fn_chkDups(vc, ev, saveNewFn) {
	if (ev) ev.preventDefault();

	kbdpAlert.showSaving(vc.c_apppEntName);

	console.log("In fn_chkDups");
	let recform = $(vc.$refs['rec-form']);
	console.log(recform);
	let nmKey = vc.d_appEnt.nameKey;
	console.log(nmKey);
	//let nmSel = `#${vc.d_appEnt.key}Rec_${nmKey}`;
	let nmSel = `#${nmKey}`;
	console.log(nmSel);
	let nmElem = recform.find(nmSel);
	console.log(nmElem);
	nmElem.one('change', (e) => {vc.d_duplicates = null;});

	let recordName = nmElem[0].value;
	fn_checkDuplicates(vc.d_appEnt.name, {recordName}).then((resp) => {
		if (resp.error) {
			let msg = `Unable to save ${vc.c_apppEntName}. ${resp.error}`;
			kbdpAlert.showErr(msg);
			return;
		}

		vc.d_duplicates = resp.duplicates;
		if (vc.d_duplicates) {
			kbdpAlert.clear();
			let content = {
				titleText: 'Duplicate Check',
				message1: `The ${vc.c_apppEntName} you are creating may already exist. Click "Review Duplicates" to view the list of possible duplicates.`,
			};
			let cm = util.fn_getModal_confirm(vc, content);
			cm.opt.okTitle = 'Review Duplicates';
			vc.$bvModal.msgBoxOk(cm.msgVNodes, cm.opt).then(() => {
				let $rcd = $(vc.$el).find('.rec-create-dups > div');
				$rcd.toggleClass('highlight');
				// setTimeout(() => {$rcd.toggleClass('highlight');}, 2000);
				let $elem = vc.p_isModal ? $rcd.closest('.modal-body') : $('html');
				$elem.animate({
					scrollTop: $elem[0].scrollHeight - $elem[0].clientHeight
				}, 300);
			});
		}
		else {
			if (saveNewFn) saveNewFn();
			else fn_saveRoutine(vc);
		}
	});
}

function fn_saveRoutine(vc) {

	kbdpAlert.showSaving(vc.c_apppEntName);

	vc.p_saveFn().then((resp, err) => {

		if (resp.error) {
			let msg = `Unable to save ${vc.c_apppEntName}. ${resp.error}`;
			kbdpAlert.showErr(msg);
			return;
		}


		let href = util.fn_hrefVwRec(vc.d_appEnt.key, '');
		let numKey = vc.d_appEnt.numKey;
		let nameKey = vc.d_appEnt.nameKey;
		let msgCntxt;
		if (vc.p_mode == 'create') {
			if (!resp.newRecHdr) {
				let msg = `Unable to create ${vc.c_apppEntName}. ${resp.error}`;
				kbdpAlert.showErr(msg);
				return;
			}

			href = href + resp.newRecHdr[numKey];
			msgCntxt = resp.newRecHdr[nameKey] + '" is Created';
		}
		else if (vc.p_mode == 'edit') {
			href = href + vc.p_recData[numKey];
			msgCntxt = vc.p_recData[nameKey] + '" is Saved';
		}

		fn_wss_rwsc();

		vc.$router.push({path: href});

		let msg = `${vc.c_apppEntName} "${msgCntxt} Successfully.`;
		kbdpAlert.showOk(msg);

	});
}

function fn_deleteRoutine(vc) {

	let recordLabel = `${vc.c_apppEntName} "${vc.p_recData[vc.d_appEnt.nameKey]}"`;
	let content = {
		titleText: 'Confirm Delete',
		message1: `Are you sure you want to delete the ${recordLabel}?`,
		message2:`Please be aware that once deleted, you will not be able to retrieve this ${vc.c_apppEntName} 
				   and all information associated with it.`,
		
	};
	let cm = util.fn_getModal_confirm(vc, content);

	vc.$bvModal.msgBoxConfirm(cm.msgVNodes, cm.opt).then((resp) => {
		if (!resp) return;

		kbdpAlert.showDeleting(vc.c_apppEntName);

		let appEntNm = vc.d_appEnt.name;
		let recId = vc.p_recData[vc.d_appEnt.idKey];
		fn_deleteRecord(appEntNm, recId).then(resp => {
			if (resp.error || !resp.status) {

				let fkRefErr = resp.error == 'FKRef' ? `\nThe ${vc.c_apppEntName} you are trying to delete is referenced in (related to) one or more records in the system. Please review and remove the reference(s) then try again.` : null;
				let msg = `Unable to delete ${recordLabel}. ` + (fkRefErr || resp.error || '');
				kbdpAlert.showErr(msg);
				return;
			}
			vc.$router.push({path: '#' + vc.d_appEnt.key});
			kbdpAlert.showOk(recordLabel + " is Deleted Successfully.");
		});
	});
}

function fn_wss_rwsc() {
	window.sessionStorage.setItem('rec-wrap-save-cancel', true);
}
</script>

<style scoped lang="less" >
.rec-wrap {
	.rec-wrap-header-1 {
		> div {
			display: flex;
			> div:first-child {
				display: flex;
				align-items: center; //Important, prevents child button heights from growing
				flex-wrap: wrap;
				flex-grow: 0;
			}
			> div:nth-child(2) {
				display: flex;
				text-align: left;
				flex-grow: 1;
				flex-wrap: wrap;

				> .btn {
					flex-shrink: 0;
					height: 21px;
					min-width: 100px;
				}
			}
			> div:nth-child(3) {
				text-align: right;
				margin: auto 0;
			}
			> h6 {
				margin: auto 0;
				padding: 0.2em 0;
				// margin-right: 1em;
				color: #4fa4ff;
			}
			> div.cln-tsk {
				width: 100%;
				text-align: left;
				padding-top: 0.5em;
				> input {
					margin-right: 0.3em;
				}
			}
		}
		.btn-edit,
		.btn-clone,
		.btn-back,
		.btn-alt-view {
			min-width: 50px;
			padding: 0em 0.4em;
			margin-right: 0.5em;
			svg {
				margin-right: 0.4em;
				font-size: 0.9em;
			}
		}

		.btn-alt-view {
			font-size: 0.8em;
			margin: 0.25em 0.25em;
			// @media (max-width: 768px) {
			// 	min-width: 145px;
			// }
		}

		.dropdown.opt-reminder > button,
		.btn-chat,
		.btn-pdf,
		.btn-excel,
		.btn-template,
		.btn-email,
		.btn-refresh,
		.btn-note
		//.notes-btn
		.btn-delete {
			font-size: 0.8em;
			width: 23px;
			padding: 0.1em 0em;
			margin: 0.25em 0;
			margin-left: 0.5em;
			border:none;
		}

		.opt-reminder .btn .kt-bbl {
			background-color: #4fa4ff;
		}
	}
	.rec-wrap-header-2 {
		padding: 0.1em 0;
		border-bottom: solid 0.1em #ced4da;
		font-size: 0.9em;
		font-weight: bolder;
	}
	.btn-save,
	.btn-cancel {
		min-width: 50px;
		padding: 0em 0.4em;
		margin-right: 0.5em;
	}
	.rec-wrap-form {
		display: flex;
		//padding: 0.5em 0;
		justify-content: space-between;
		flex-direction: row;
		@media (max-width: 992px) {
			flex-direction: column;
		}
	}
	.rec-form,
	.rec-create-dups {
		max-width: 1200px;
	}

	.rec-form-left.form-group,
	.rec-form-right.form-group,
	.rec-form-center.form-group,
	.rec-create-dups {
		padding-left: 0; //For dups
		padding-right: 8%;
		@media (max-width: 768px) {
			padding-right: 0;
		}
	}
	.form-group {
		min-width: 250px;

		> label {
			font-size: 0.9em;
			margin-bottom: 0.1em;
		}
		> span.tt-info {
			font-size: 0.8em;
			vertical-align: middle;
		}
		input,
		select,
		textarea {
			&:invalid {
				border-color: #dc3545;
				box-shadow: none;
			}
		}
		> .custom-control.custom-checkbox {
			// display: inline-block;
			label {
				margin: 0;
				line-height: 1.75em;
			}
		}
		> span.note {
			display: inline-block;
			font-size: 0.8em;
			color: #4fa4ff;
			// line-height: 1em;
		}
	}

	.rec-create-dups {
		font-size: 0.9em;
		tr {
			td {
				padding: 0 0.5em 0 0;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
			}
			@media (max-width: 576px) {
				display: flex;
			}
		}

		.highlight {
			// border-width: 0!important;
			box-shadow: 0em 0.01em 0.01em 0.1em #ffc107;
		}
	}
	.rec-wrap-rec-meta {
		margin-top: 1em;
		background-color: #f8f9fa;
		font-size: 0.9em;
		max-height: 400px;

		border: solid 0.1em #ced4da;
		border-right: none;
		border-top-left-radius: 0.2em;
		border-bottom-left-radius: 0.2em;

		> div :nth-child(2) {
			min-width: 200px;
		}
		@media (max-width: 992px) {
			border-right: solid 0.1em #ced4da;
			border-top-right-radius: 0.2em;
			border-bottom-right-radius: 0.2em;
			margin-right: 8%;
			margin-bottom: 1em;
		}
		@media (max-width: 768px) {
			margin-right: 0;
		}
		// @media (min-width: 1600px) {
		// 	div:last-child {
		// 		display: block !important;
		// 	}
		// }
		.btn-rec-meta {
			margin: 0.1em 0.1em;

			&:hover {
				background-color: #e9ecef;
			}
		}
		label {
			margin-bottom: 0;
		}
		span,
		p {
			background-color: #e9ecef;
			padding: 0.2em 1em 0.2em 0.5em;
			border-color: #ced4da;
		}
	}

	.input-group-prepend {
		.input-group-text {
			font-size: 0.9em;
			color: #6c757d;
			justify-content: center;
			padding: 0em 0.75em;
			width: 25px;

			border-top-right-radius: 0;
			border-bottom-right-radius: 0;
			border-right: none;

			&[disabled] {
				pointer-events: none;
			}
		}
		input,
		textarea,
		select {
			border-top-left-radius: 0;
			border-bottom-left-radius: 0;
		}
	}
}
.cardDropDown {
		min-width: 250px;
		.card-header {
			background-color: unset;
			padding: 0.2em 0.5em;
			margin-bottom: 0.5em;
			img {
				border-radius: 1em;
				margin-right: 0.5em;
				height: 30px;
			}
			span {
				vertical-align: middle;
			}
		}
		.card-body {
			font-size: 0.9em;
			padding: 0em 1em;
			padding-bottom: 0.5em;
			> label {
				margin-bottom: 0;
				display: block;
			}
		}
	}
.noborder{border:none;}
.btn-delete {
	color: #dc3545;
	text-align: center;
	}
.header1-sticky{
	position:sticky;
	top:82px;
	background:white;
	z-index:5;
	}
.header2-sticky{
	position:sticky;
	top:105px;
	background:white;
	z-index:4;
	}
.rec-wrap-meta-sticky{
	position:sticky;
	top:160px;
	background:white;
	z-index:4;
	}
.right-icons-fixed{
		position:fixed;
		right:5px;
		}
.left1-icons-fixed{
		position:fixed;
		left:5px;
		}
.dropdown-on-top{position:sticky;
				z-index:7;
				background:white;
				}
.btn-outline-primary {
    color: #4fa4ff;
    border:none;
}
.btn-menu{
	border:none;
	padding:0 .5rem;
	}
.notes-btn
	{
	font-size: 0.8em;
	width: 25px;
	height:20px;
	color:#007bff;
	margin-right: 10px;
	border:none;
}
right-icons-div {
position:absolute;
right:5px; 
display:flex;
}
.toolbar {
  background1: #f8f9fa;
  border1: 1px solid #e2e2e2;
  border-radius1: 6px;
  padding: 6px 10px;
}
.btn-icon {
  width1: 34px;
  height: 34px;
  padding1: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right1: 5px; /* add spacing */
}
.toolbar .btn-extra {
  background-color: white;
  color:black;
  border:none;
  padding: 6px 10px;
  align-items: center;
}
.action-menu {
  position: absolute;
  top: 100%;        /* directly below the button */
  right: 0;         /* align right edge with button */
  background: white;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.12);
  padding: 6px 0;
  min-width: 180px;
  z-index: 1000;
}
.menu-wrapper {
  position: relative;
  display: inline-block; /* keeps menu aligned with the button */
  margin-left:50px;
}
.menu-wrapper-btn {
	border:none;
	color:black;
	background:white;
}
.caret {
  display: inline-block;
  margin-left: 6px;
  width: 0;
  height: 0;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 5px solid #555; /* soft gray */
  vertical-align: middle;
}
.caret.open1 {
  transform: rotate(180deg);
}



</style>